import React from 'react';
import { Radio, Row, Col, Button } from 'antd';
import { rgbToHex2 } from '../../../helpers/helpers';
// import { ZoomInOutlined, ZoomOutOutlined } from '@ant-design/icons';
import { Crop, ZoomIn, ZoomOut, CornerUpLeft } from 'react-feather'


const TopBar = (props) => {



    const zoomIn = () => {
        const img = new Image();
        img.src = URL.createObjectURL(props.file);
        img.onload = function () {
            const canvas = document.getElementById("canvas");
            const [imgWidth, imgHeight] = [Math.floor(props.crop.width * (props.scale + 0.1)), Math.floor(props.crop.height * (props.scale + 0.1))];
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            canvas.getContext("2d").drawImage(img, props.crop.x, props.crop.y, props.crop.width, props.crop.height, 0, 0, imgWidth, imgHeight);
            props.setScale(props.scale + 0.1);
        }
    }

    const zoomOut = () => {
        const img = new Image();
        img.src = URL.createObjectURL(props.file);
        img.onload = function () {
            if ((props.scale - .1) > 0) {
                const canvas = document.getElementById("canvas");
                const [imgWidth, imgHeight] = [Math.floor(props.crop.width * (props.scale - 0.1)), Math.floor(props.crop.height * (props.scale - 0.1))];
                canvas.width = imgWidth;
                canvas.height = imgHeight;
                canvas.getContext("2d").drawImage(img, props.crop.x, props.crop.y, props.crop.width, props.crop.height, 0, 0, imgWidth, imgHeight);
                props.setScale(props.scale - 0.1);
            }
        }
    }




    return (
        <div>
        <Row justify='left' style={{  height: '43px', borderStyle: "solid", borderColor: "#cfcfcf", borderBottomWidth: "1px", borderTopWidth: "0px", borderLeftWidth: "0px", borderRightWidth: "0px",}}>
        <Col >
            <Button type="text" onClick={() => { props.setFile("") }} style={{  width: "100%" ,marginTop: "5px"  }}><CornerUpLeft size={16}/></Button>
        </Col>
        <Col >
            <Button type="text" onClick={() => { props.setIsCropVisible(true) }} style={{ width: "100%",  marginTop: "5px"}}><Crop size={16}/></Button>
            </Col>
        <Col >
            {/* <Radio.Group> */}
            <Button  type="text" style={{ marginTop: "5px"}}onClick={() => zoomOut()}><ZoomOut size={16}/></Button>
                <Button  type="text" style={{ marginTop: "5px"}} onClick={() => zoomIn()}><ZoomIn size={16}/></Button>

            {/* </Radio.Group> */}
        </Col>
    </Row>

        </div>
    );
};

export default TopBar;